export default __webpack_public_path__ + "static/media/BOPPanhandleFirstBankDentalPlanBrandingLogo.e07ccc66.png";